/**
 * オンボーディングチュートリアル
 * 設定画面の任意のページにサイドバーとして表示されるチュートリアルコンポーネント
 *
 * 使用例:
 * <tutorial-sidebar
 *   step-key="service_setting">
 * </tutorial-sidebar>
 */
angular.module('inspinia').directive('tutorialSidebar', [
  'tutorialService',
  'tutorialSystemDataService',
  '$state',
  '$sce',
  function (tutorialService, tutorialSystemDataService, $state, $sce) {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        stepKey: '@',
      },
      templateUrl: `src/view/directive/project/tutorial/tutorial_sidebar.html?${new Date().getTime()}`,
      link: function (scope) {
        scope.sidebarCollapsed = false;
        scope.showCompletionMessage = false;
        scope.completionMessage = '';
        scope.stepNumber = '';
        scope.stepTitle = '';
        scope.stepDescription = '';
        scope.manualUrl = '';
        scope.showSidebar = false;

        const initializeTutorial = () => {
          const tutorial = scope.$parent.tutorial;
          const stepInfo = tutorialService.getTutorialStepInfo(tutorial, scope.stepKey);

          if (!stepInfo) {
            scope.showSidebar = false;
            return;
          }

          scope.tutorial = tutorial;
          scope.tutorial.steps = stepInfo.normalizedSteps;
          scope.currentStep = stepInfo.step;
          scope.currentStepIndex = stepInfo.index;
          scope.showSidebar = stepInfo.isVisible;

          // 表示情報をシステム設定から取得する
          scope.stepNumber = stepInfo.index + 1;
          scope.stepTitle = tutorialSystemDataService.getSystemArrayValue(
            scope.$parent,
            'array_tutorial_step_title',
            stepInfo.index
          );
          scope.stepDescription = tutorialSystemDataService.getSystemArrayValue(
            scope.$parent,
            'array_tutorial_step_description',
            stepInfo.index
          );
          scope.manualUrl = tutorialSystemDataService.getSystemArrayValue(
            scope.$parent,
            'array_tutorial_step_manual_link',
            stepInfo.index
          );
        };

        scope.toggleSidebar = () => {
          scope.sidebarCollapsed = !scope.sidebarCollapsed;
        };

        scope.completeStep = () => {
          if (scope.currentStep && scope.$parent) {
            const stepIndex = scope.tutorial.steps.findIndex((step) => step.key === scope.stepKey);
            tutorialService.completeTutorialStep(scope.$parent, scope.currentStep, stepIndex, true, false);

            if (scope.tutorial.steps.every((step) => step.complete)) {
              scope.completionMessage = $sce.trustAsHtml('全ての初期設定ステップを完了しました！');
              scope.showCompletionMessage = true;
              return;
            }

            const completionMessageText = tutorialSystemDataService.getSystemArrayValue(
              scope.$parent,
              'array_tutorial_step_complete_message',
              stepIndex
            );

            scope.completionMessage = completionMessageText;
            scope.showCompletionMessage = true;
          }
        };

        scope.goToDashboard = () => {
          $state.go('dashboard', null, { reload: true });
        };

        scope.$parent.getMine().then(() => {
          const serviceId = scope.$parent.my.current_service_id
            ? scope.$parent.my.current_service_id
            : scope.$parent.my.service_id;

          scope.$parent.getService(serviceId).then(() => {
            // tutorialServiceが冪等性を保証するため、常に呼び出して問題ない
            tutorialService.setTutorial(scope.$parent);
            initializeTutorial();
          });
        });
      },
    };
  },
]);
